import { VerifyStageEnum } from '@/views_v2/verify-credit/types';
import { PresentationConfig, PresentationThemeEnum } from './types';


/** 现金活动配置 */
export const CASH_ACTIVITY_CONFIG: PresentationConfig = {
  theme: PresentationThemeEnum.PLATFORM_BLUE,
  [VerifyStageEnum.ID_CARD]: {
    title: '送5元现金红包',
    ruleText: `
      1.未完成过实名认证的用户可以参与本次活动<br/>
      2.一个用户仅支持使用一个身份信息参与一次活动<br/>
      3.完成活动即可获得奖励，现金红包可通过 哈啰APP-钱包-余额查收。
    `,
    submitText: '提交 领取奖励',
  },
};

/** 零用钱第一阶段配置 */
export const POCKET_MONEY_FIRST_INFO_CONFIG: PresentationConfig = {
  [VerifyStageEnum.ID_CARD]: {
    title: '继续提现',
    submitText: '下一步',
  },
};
